import React from "react";

interface PaginationProps {
  currentPage: number;
  lastPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  lastPage,
  onPageChange,
}) => {
  const [displayPages, setDisplayPages] = React.useState<(number | string)[]>(
    []
  );
  const [leftGapPage, setLeftGapPage] = React.useState<number | null>(null);
  const [rightGapPage, setRightGapPage] = React.useState<number | null>(null);

  React.useEffect(() => {
    let pages: (number | string)[] = [];

    if (lastPage <= 7) {
      pages = [];
      for (let i = 1; i <= lastPage; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        pages = [1, 2, 3, 4, 5, "gap_right", lastPage];
        setRightGapPage(lastPage - 1);
      } else if (currentPage >= lastPage - 3) {
        pages = [
          1,
          "gap_left",
          lastPage - 4,
          lastPage - 3,
          lastPage - 2,
          lastPage - 1,
          lastPage,
        ];
        setLeftGapPage(2);
      } else {
        pages = [
          1,
          "gap_left",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "gap_right",
          lastPage,
        ];
        setLeftGapPage(2);
        setRightGapPage(lastPage - 1);
      }
    }

    setDisplayPages(pages);
  }, [currentPage, lastPage]);

  return (
    <div className="pagination-wrapper mb-4">
      {lastPage > 1 && (
        <div className="pagination">
          <div
            onClick={() => onPageChange(currentPage - 1)}
            className={`link ${currentPage === 1 ? "disabled" : ""}`}
            aria-label="Previous"
          >
            <div className="link-icon">
              <i className="fas fa-angle-left"></i> <span>戻る</span>
            </div>
          </div>

          {displayPages.map((page, index) =>
            page === "gap_left" ? (
              <div
                key={index}
                onClick={() => onPageChange(leftGapPage!)}
                className="link"
              >
                ...
              </div>
            ) : page === "gap_right" ? (
              <div
                key={index}
                onClick={() => onPageChange(rightGapPage!)}
                className="link"
              >
                ...
              </div>
            ) : (
              <div
                key={index}
                onClick={() => onPageChange(page as number)}
                className={`link ${page === currentPage ? "active" : ""}`}
              >
                {page}
              </div>
            )
          )}

          <div
            onClick={() => onPageChange(currentPage + 1)}
            className={`link ${currentPage === lastPage ? "disabled" : ""}`}
            aria-label="Next"
          >
            <div className="link-icon">
              <span>次へ</span> <i className="fas fa-angle-right"></i>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pagination;
